/* This is the EMIS Staff Salary components */

<template>
  <v-container>
    <div>
      <span v-html="title"></span>
    </div>
    <div>
      <table border="1px;" cellspacing="0px;">
        <tbody>
          <tr>
            <td
              style="width: 150px; text-align: center; vertical-align: middle"
              rowspan="2"
            >
              ក្របខ័ណ្ឌ
            </td>
            <td style="width: 100px; text-align: center" colspan="2">
              បុគ្គលិកបង្រៀន
            </td>
            <td
              style="width: 100px; height: 25px; text-align: center"
              colspan="2"
            >
              បុគ្គលិកមិនបង្រៀន
            </td>
            <td
              style="width: 100px; height: 25px; text-align: center"
              colspan="2"
            >
              បុគ្គលិកបង្រៀនខ្ចីពីបឋម
            </td>
          </tr>
          <tr style="height: 25px; text-align: center">
            <td style="width: 50px">សរុប</td>
            <td style="width: 50px">ស្រី</td>
            <td style="width: 50px">សរុប</td>
            <td style="width: 50px">ស្រី</td>
            <td style="width: 50px">សរុប</td>
            <td style="width: 50px">ស្រី</td>
          </tr>
          <tr
            v-for="(value, row) in d1.length"
            :key="row"
            style="height: 25px; text-align: center"
          >
            <td style="width: 150px; height: 25px">{{ d1[row] }}</td>
            <td style="width: 60px; height: 25px">
              <numberinput v-model="data[row].dt[0]" style="width: 50px" />
            </td>
            <td style="width: 60px; height: 25px">
              <numberinput v-model="data[row].dt[1]" style="width: 50px" />
            </td>
            <td style="width: 60px; height: 25px">
              <numberinput v-model="data[row].dt[2]" style="width: 50px" />
            </td>
            <td style="width: 60px; height: 25px">
              <numberinput v-model="data[row].dt[3]" style="width: 50px" />
            </td>
            <td style="width: 60px; height: 25px">
              <numberinput v-model="data[row].dt[4]" style="width: 50px" />
            </td>
            <td style="width: 60px; height: 25px">
              <numberinput v-model="data[row].dt[5]" style="width: 50px" />
            </td>
          </tr>
          <!-- Total Row data, last two columns do not draw and sum -->
          <tr style="height: 25px; text-align: center">
            <td style="width: 150px; height: 25px">សរុប</td>
            <td
              v-for="(value, col) in totalRow.length - 4"
              :key="col"
              style="width: 50px; height: 25px"
            >
              {{ totalRow[col] }}
            </td>
          </tr>
        </tbody>
      </table>
      <br />
      <table border="0px;" cellspacing="1em;">
        <tr cellspacing="1px;">
          <td style="width: 310px; text-align: right">
            ចំនួនគ្រូជាប់កិច្ចសន្យាកំពុងជួយបង្រៀន:
          </td>
          <td style="width: 100px; text-align: right">
            សរុប៖<numberinput
              v-model="data[0].dt[6]"
              style="width: 50px; border: 2px solid #ccc"
            />
          </td>
          <td style="width: 100px; text-align: right">
            ស្រី៖<numberinput
              v-model="data[0].dt[7]"
              style="width: 50px; border: 2px solid #ccc"
            />
          </td>
        </tr>
        <tr cellspacing="1px;">
          <td style="width: 310px; text-align: right">
            ចំនួនបុគ្គលិកបង្រៀនដែលខ្វ:
          </td>
          <td style="width: 100px; text-align: right">
            សរុប៖<numberinput
              v-model="data[1].dt[6]"
              style="width: 50px; border: 2px solid #ccc"
            />
          </td>
          <td style="width: 100px; text-align: right">
            ស្រី៖<numberinput
              v-model="data[1].dt[7]"
              style="width: 50px; border: 2px solid #ccc"
            />
          </td>
        </tr>
        <tr>
          <td style="width: 310px; text-align: right">
            ចំនួនបុគ្គលិកបង្រៀនដែលលើស:
          </td>
          <td style="width: 100px; text-align: right">
            សរុប៖<numberinput
              v-model="data[2].dt[6]"
              style="width: 50px; border: 2px solid #ccc"
            />
          </td>
          <td style="width: 100px; text-align: right">
            ស្រី៖<numberinput
              v-model="data[2].dt[7]"
              style="width: 50px; border: 2px solid #ccc"
            />
          </td>
        </tr>
        <tr>
          <td style="width: 310px; text-align: right">
            បុគ្គលិកបង្រៀនទទួលការបណ្តុះបណ្តាលថ្នាក់បរិយាបន្ន:
          </td>
          <td style="width: 100px; text-align: right">
            សរុប៖<numberinput
              v-model="data[0].dt[8]"
              style="width: 50px; border: 2px solid #ccc"
            />
          </td>
          <td style="width: 100px; text-align: right">
            ស្រី៖<numberinput
              v-model="data[0].dt[9]"
              style="width: 50px; border: 2px solid #ccc"
            />
          </td>
        </tr>
        <tr>
          <td style="width: 310px; text-align: right">
            បុគ្គលិកបង្រៀនបានធ្វើបច្ចុប្បន្នកម្មកិច្ចតែងការបង្រៀន:
          </td>
          <td style="width: 100px; text-align: right">
            សរុប៖<numberinput
              v-model="data[1].dt[8]"
              style="width: 50px; border: 2px solid #ccc"
            />
          </td>
          <td style="width: 100px; text-align: right">
            ស្រី៖<numberinput
              v-model="data[1].dt[9]"
              style="width: 50px; border: 2px solid #ccc"
            />
          </td>
        </tr>
        <tr>
          <td style="width: 310px; text-align: right">
            បុគ្គលិកបង្រៀនបានឆ្លងកាត់ការបណ្តុះបណ្តាលពីសាលាគរុកោសល្យមត្តេយ្យមជ្ឍឹម:
          </td>
          <td style="width: 100px; text-align: right">
            សរុប៖<numberinput
              v-model="data[2].dt[8]"
              style="width: 50px; border: 2px solid #ccc"
            />
          </td>
          <td style="width: 100px; text-align: right">
            ស្រី៖<numberinput
              v-model="data[2].dt[9]"
              style="width: 50px; border: 2px solid #ccc"
            />
          </td>
        </tr>
      </table>
    </div>
  </v-container>
</template>

<script>
import { d1 } from "@/utils/ascf/commonConfig.js";
import NumberInput from "@/components/common/NumberInput.vue";
export default {
  props: ["data", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      d1: d1,
    };
  },
  computed: {
    // need to update the total staff in json data
    totalRow: function () {
      let result;
      let d = this.data;
      let ldata = this.data.length - 1;

      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (ind < ldata) {
            // do summing 0 to last - 1 only (last is sum array)
            r[i] = (r[i] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      // update the total row array in JSON
      d[ldata].dt.forEach(function (b, i) {
        d[ldata].dt[i] = result[i];
      });
      return result;
    },
  },
};
</script>
<style scoped>
</style>